import React, { useMemo, useState } from 'react';
import { Button, Checkbox, Form, Tabs, Modal } from 'antd';
import { useLoginForm } from '../hooks/useLoginForm';
import DEFAULT_AGREEMENT from '../constants/defaultAgreement';

import AccountLoginForm from './AccountLoginForm';
import PhoneLoginForm from './PhoneLoginForm';
import QrCodeLoginForm from './QrCodeLoginForm';
import ThirdPartyLogin from './ThirdPartyLogin';

/**
 * 登录表单容器组件
 * 使用自定义Hook进行状态管理和性能优化
 */
const LoginForm = React.memo(() => {
  const {
    loading,
    activeTab,
    form,
    handleTabChange,
    handleLogin
  } = useLoginForm();
  const [agreementVisible, setAgreementVisible] = useState(false);

  // 使用useMemo优化tab配置，避免不必要的重新渲染
  const tabItems = useMemo(() => [
    {
      key: 'account',
      label: '账号登录',
      children: <AccountLoginForm />,
    },
    {
      key: 'phone',
      label: '短信登录',
      children: <PhoneLoginForm />,
    },
    {
      key: 'qrcode',
      label: '扫码登录',
      children: <QrCodeLoginForm />,
    }
  ], []);

  React.useEffect(() => {
    form.setFieldValue('activeTab', 'account');
  }, [form]);



  return (
    <Form form={form} className='w-full'>
      <div className='min-h-[350px] min-w-[330px]'>
        <Tabs
          activeKey={activeTab}
          onChange={handleTabChange}
          className='w-full'
          items={tabItems}
        />
        {activeTab !== 'qrcode' && (
          <>
            <div className='w-full mt-6'>
              <Form.Item
                name="agreement"
                valuePropName="checked"
                rules={[{ required: true, message: '请先阅读并同意使用协议' }]}
                style={{ marginBottom: 0 }}
              >
                <Checkbox>
                  <span className='text-sm text-slate-400'>是否同意贯石科技</span>
                  <span
                    className='text-sm text-[#791A3E] underline cursor-pointer'
                    onClick={e => { e.preventDefault(); setAgreementVisible(true); }}
                  >
                    使用协议
                  </span>
                </Checkbox>
              </Form.Item>
            </div>
            <Button 
              className='mt-3 w-full transition-all duration-300' 
              size='large' 
              type="primary"
              loading={loading}
              onClick={async () => {
                try {
                  await form.validateFields();
                  handleLogin();
                } catch (e) {
                  // 校验未通过，不调用handleLogin
                }
              }}
            >
              {loading ? '登录中...' : '登录'}
            </Button>
            <Modal
              open={agreementVisible}
              title="贯石科技平台使用协议"
              onOk={() => setAgreementVisible(false)}
              onCancel={() => setAgreementVisible(false)}
              okText="我已阅读并同意"
              cancelText="取消"
              width={520}
            >
              <div style={{ whiteSpace: 'pre-wrap', maxHeight: 360, overflowY: 'auto' }}>{DEFAULT_AGREEMENT}</div>
            </Modal>
          </>
        )}
      </div>
      <ThirdPartyLogin />
    </Form>
  );
});

LoginForm.displayName = 'LoginForm';

export default LoginForm;